import { useCallback, useState } from 'react';

const DEFAULT_PAGE_SIZE = 10;

/**
 * Table-control state for the Distribution page (CT-4206): search, status
 * filter, sort (name/status/owner), and pagination. Kept out of
 * `DistributionPage` so the component owns only its edit mode (CT-4207) and
 * rendering. Any control change that alters the result set resets to page 1.
 */
export function useDistributionTableState() {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('all');
  const [sortKey, setSortKey] = useState('name');
  const [sortDir, setSortDir] = useState('asc');
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(DEFAULT_PAGE_SIZE);

  // Run a control update and snap back to page 1 (search/filter change).
  const resetPage = useCallback((updater) => {
    updater();
    setPage(1);
  }, []);

  const toggleSort = useCallback(
    (key) => {
      setPage(1);
      if (key === sortKey) {
        setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
      } else {
        setSortKey(key);
        setSortDir('asc');
      }
    },
    [sortKey],
  );

  return {
    search,
    setSearch,
    status,
    setStatus,
    sortKey,
    sortDir,
    toggleSort,
    page,
    setPage,
    perPage,
    setPerPage,
    resetPage,
  };
}
